'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartLegendTranslationProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../checkbox/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../../list/index');

var _withChartLegend = require('../with-chart-legend');

require('./chart-legend.scss');

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _classnames = require('../../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _textToHtml = require('../../../utils/text-to-html');

var _textToHtml2 = _interopRequireDefault(_textToHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartLegend(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === undefined ? [] : _ref$data,
      labelKey = _ref.labelKey,
      isPhone = _ref.isPhone,
      translation = _ref.translation,
      onSelectAll = _ref.onSelectAll,
      onToggle = _ref.onToggle;

  var classes = (0, _classnames2.default)('chart-legend', !isPhone && 'chart-legend--position-absolute');

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(
      _index3.List,
      null,
      _react2.default.createElement(
        _index3.ListItem,
        { key: 'select-all' },
        _react2.default.createElement(
          _index2.default,
          {
            align: 'center',
            size: 'small',
            checked: data.map(function (d) {
              return d.checked;
            }).every(function (c) {
              return c;
            }),
            onChange: function onChange(event) {
              return onSelectAll(event.target.checked);
            }
          },
          translation.selectAllLabel
        )
      ),
      data.map(function (entity, index) {
        return _react2.default.createElement(
          _index3.ListItem,
          { key: entity[labelKey] },
          _react2.default.createElement(
            _index2.default,
            {
              className: 'chart-legend__checkbox',
              align: 'center',
              size: 'small',
              checked: entity.checked,
              onChange: function onChange(event) {
                return onToggle(entity, event.target.checked);
              },
              style: { color: (0, _utils2.default)(index) }
            },
            (0, _textToHtml2.default)(entity[labelKey])
          )
        );
      })
    )
  );
}

var ChartLegendTranslationProps = exports.ChartLegendTranslationProps = {
  selectAllLabel: _propTypes2.default.string
};

ChartLegend.propTypes = {
  data: _propTypes2.default.arrayOf(_withChartLegend.elementsPropType).isRequired,
  isPhone: _propTypes2.default.bool.isRequired,
  labelKey: _propTypes2.default.string.isRequired,
  translation: _propTypes2.default.shape(ChartLegendTranslationProps),
  onSelectAll: _propTypes2.default.func.isRequired,
  onToggle: _propTypes2.default.func.isRequired
};

ChartLegend.defaultProps = {
  translation: {
    selectAllLabel: 'Select All'
  }
};

exports.default = ChartLegend;